const apiBaseUrl = 'https://api.tgk.family:8686';

export function fetchData (url) {
  return fetch(`${apiBaseUrl}/${url}`)
  .then((response) => response.json())
}